import React, { forwardRef, type Ref } from 'react'

import type { ReactAnchorProps } from '../types'
import { useLinkComponent } from './LinkProvider'

export const UnstyledAnchor = forwardRef(function _UnstyledAnchor(
  props: ReactAnchorProps,
  ref?: Ref<HTMLAnchorElement>
) {
  const LinkComponent = useLinkComponent()
  const linkProps = {
    css: {
      color: 'inherit',
      textDecoration: 'none',
    },
    'data-testid': props['data-testid'],
    ref,
    ...props,
  }
  if (props.href === undefined) {
    return <NonHrefLinkComponent {...linkProps} />
  }

  return <LinkComponent {...linkProps} />
})

/**
 * (NOTE: Adam) Need a special bail out component to handle links without hrefs.
 * The web-app coerces all LinkComponents to have a defined href creating an actual "link", so this
 * will allow design system components to use the `UnstyledAnchor` for styling
 * purposes turning them into actual links. See `NavigationRow.tsx`
 */
function NonHrefLinkComponent({ children, ...props }: ReactAnchorProps) {
  return <a {...props}>{children}</a>
}
